import * as React from 'react';
import { translate } from '@deltasierra/i18n';
import styled from 'styled-components';
import { DateTimePickerProps, DateTimePicker } from '../DateTimePicker';

export type DateRangePickerProps = Pick<DateTimePickerProps, 'type'> & {
    className?: string;
    errors?: { from?: string; to?: string };
    from: string;
    style?: React.CSSProperties;
    to: string;
    onBlur?: (event: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
    onFromChange: (newValue: string) => void;
    onToChange: (newValue: string) => void;
};

const Flexor = styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
`;

/**
 * @deprecated - We now use two DatePicker components, which provides a clearer, more accessible experience
 * @param props - DateRangePickerProps
 * @returns picks two dates
 */
export const DateRangePicker = (props: DateRangePickerProps): JSX.Element => {
    const { errors, from, onBlur, onFromChange, onToChange, to, type } = props;
    const { className, style } = props;

    return (
        <Flexor {...{ className, style }}>
            <DateTimePicker
                error={!!errors?.from}
                fullWidth
                helperText={errors?.from}
                style={{ flexGrow: 1 }}
                type={type}
                value={from}
                onBlur={onBlur}
                onChange={onFromChange}
            />
            <div style={{ display: 'inline-block', margin: '8px 20px 4px 20px' }}>
                {translate('COMMON.AND').toLocaleLowerCase()}
            </div>
            <DateTimePicker
                error={!!errors?.to}
                fullWidth
                helperText={errors?.to}
                style={{ flexGrow: 1 }}
                type={type}
                value={to}
                onBlur={onBlur}
                onChange={onToChange}
            />
        </Flexor>
    );
};
DateRangePicker.displayName = 'DateRangePicker';
